<template>
  <div class="mx-2 mt-2">
    <!-- Outer box centered (fixed readable width) -->
    <div :class="headerClass">
      <!-- HEADER-SLOT mit Default -->
      <slot name="header" :translatedParams="translatedParams" :showTasks="showTasks">
        <!-- Default header (wird genutzt, wenn kein header-Slot gesetzt ist) -->
        <h2 class="text-center">
          <span v-tooltip="{ value: translatedParams?.description }" class="cursor-help">
            {{ translatedParams?.title }}
          </span>
        </h2>

        <div class="mt-2 text-left">
          <p v-if="showTasks">
            {{ translatedParams?.shortDescription }}
          </p>
        </div>
      </slot>
    </div>

    <!-- Slot-Container: centered, left-aligned, can grow wide -->
    <div class="mt-6 mx-auto w-full max-w-screen-lg xl:max-w-screen-xl px-3 sm:px-4 text-left">
      <div class="min-w-0">
        <slot />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, isRef, toRefs } from 'vue';

type InlineWrapperProps = {
  translatedParams?: any;
  showTasks?: boolean;
  headerClass?: string;
};

const props = withDefaults(defineProps<InlineWrapperProps>(), {
  translatedParams: {},
  headerClass: 'w-full max-w-2xl mx-auto p-4',
});

const { showTasks } = toRefs(props);

const translatedParams = computed(() => {
  const v = props.translatedParams;
  // If parent passed a ref/computed, unwrap once
  return isRef(v) ? (v.value ?? {}) : (v ?? {});
});
</script>
